import {LOAD_NAVIGATION_ITEMS} from "./constants";

export function loadNavigationItems(user) {
    return {
        type: LOAD_NAVIGATION_ITEMS,
        payload: user
    };
}